// Quick-input suggestion chips for the AI menu. Clicking one fills the prompt
// and focuses the textarea (Enter then submits) — a one-click way to start a
// common request. Two sets: editing a selection vs asking about the company
// (no selection).

export const SELECTION_CHIPS = ['Improve writing', 'Make it concise', 'Fix grammar & spelling', 'Make it more formal', 'Summarize'];

export const COMPANY_CHIPS = [
    'What does this company do?',
    'Key risks to watch',
    'Recent developments',
    'Summarize the financials',
    'Who are the main competitors?',
];
